
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91locale_93X3JGk_qgUKdJrKndvgQhpILveeV2Byfp1kQ4yJtPzvcMeta } from "/app/pages/[locale].vue?macro=true";
import { default as indexCTpaUrYoordPqa1ioz30KlBu_45swuOXj027axvyeU0nMMeta } from "/app/pages/mobile/index.vue?macro=true";
import { default as indexcg_5V1pFzzohIWI4wc_ZJWgzoHyrv2gX3lcfnUnmfhwMeta } from "/app/pages/desktop/index.vue?macro=true";
import { default as heathCheckiIlpn5D56BHDL9iTEU8t_45BPCbd0zmv_450DMdVxTyRXi4Meta } from "/app/pages/ttd/heathCheck.vue?macro=true";
import { default as html_45sitemaphJL_45bWeMKnG47PmCreLUZZ0_RvGCQO1Fw9AJIDfsDIgMeta } from "/app/pages/ttd/html-sitemap.vue?macro=true";
import { default as indexhZBRBc_iNib_45J3Uggip4oftC9g_lNqts_45xqP36G63J4Meta } from "/app/pages/mobile/coins/index.vue?macro=true";
import { default as indexje6gB4TQiwdJSnM1IStgssgpTcKAxH6eYDxAv_450SpQwMeta } from "/app/pages/desktop/coins/index.vue?macro=true";
import { default as indexIRd3AFCLR4Z8qTbGgLWn4dfGiqynPInZYd8JX_45OSWPkMeta } from "/app/pages/mobile/payment/index.vue?macro=true";
import { default as indexpfh9YZFSQxOrI2QN4dx_zYcVn7C5bXmgm93OhcWMCBMMeta } from "/app/pages/desktop/payment/index.vue?macro=true";
import { default as indexWpGboHLoQh5aQ56182wugHrTGbKJiAuCYy5gxKd_h_45oMeta } from "/app/pages/mobile/order/list/index.vue?macro=true";
import { default as indexVBe_45zLknJQ0lWGzK5uN2CMDtwnXk8k_LAYrDD_Xr1CEMeta } from "/app/pages/desktop/order/list/index.vue?macro=true";
import { default as indexPu17ZniwfBstTnYRRrETAT6sg1EbnkNc1ckAxCw085sMeta } from "/app/pages/mobile/order/create/index.vue?macro=true";
import { default as index7HvOnPGyTELPtuVQgt0qcn9SBTGRshUregE06_Ck0PEMeta } from "/app/pages/mobile/order/detail/index.vue?macro=true";
import { default as indexLO39bKLniKA6sH4wjR4ECzlL8fgV_QgRJSqg9vFeJWAMeta } from "/app/pages/mobile/order/search/index.vue?macro=true";
import { default as indexgbMt4H2ECW25g4LwI7FLmAxex0YGJohepGSTpKsWNfMMeta } from "/app/pages/mobile/order/status/index.vue?macro=true";
import { default as indexzOrI2EdUPAngZ_QxrspbjRnjDwL3oX0HygYTOKpBQGUMeta } from "/app/pages/desktop/order/create/index.vue?macro=true";
import { default as indexhHaHHUVkKSEFFZZKG74w2gNH7JeqPJHXlVexicDJx2IMeta } from "/app/pages/desktop/order/detail/index.vue?macro=true";
import { default as indextDjwI5k7jVz9BYazP5aN_45hLzXamOE_45MJCI9TAOL9l1cMeta } from "/app/pages/desktop/order/search/index.vue?macro=true";
import { default as indexp1ixPuvjBrr7nfhYjt1jYN04MNHPrchrGYX7T0UA6ikMeta } from "/app/pages/desktop/order/status/index.vue?macro=true";
import { default as indexzYf3XVV1jqXSTEFK4K9kcw93qBszBXD6Dvml7z3lHhAMeta } from "/app/pages/mobile/order/vouchers/index.vue?macro=true";
import { default as indexSQAPUqxEjEJ8fzWJttWSAxRFrJp13zF1vIGDFZlTnHgMeta } from "/app/pages/desktop/order/vouchers/index.vue?macro=true";
import { default as indexD6_45XteAn4iS1xN8uH2wYvQQ13oz54GJeWYyae6EImKAMeta } from "/app/pages/mobile/attractions/list/index.vue?macro=true";
import { default as index8g8lsCCxBOG4ZqRzi7vQh6D0gmT7VDAsOsQohiSWvbUMeta } from "/app/pages/desktop/attractions/list/index.vue?macro=true";
import { default as indexKOtkDMFIWwTq_HHl4R0akOpTGqxWolPFfwWDQ32D8hkMeta } from "/app/pages/mobile/experience/detail/index.vue?macro=true";
import { default as indexPvmVabXVYdhUIgkOfV_45tiVSs2NJOb8hVMplHl71CUpwMeta } from "/app/pages/desktop/experience/detail/index.vue?macro=true";
import { default as indexfzWNHbV0HHe8eyfLoznzu28oJ8n9mDJJV862bRHSTr4Meta } from "/app/pages/mobile/attractions/detail/index.vue?macro=true";
import { default as index32K_45QsUBOyXn8flUu3AjxxgimWATvQeYEEBpmhiNlXYMeta } from "/app/pages/desktop/attractions/detail/index.vue?macro=true";
import { default as Filter_45WtwF35rbFIuFk7gD6d6A4HoIe9z1j77WWkl923n7p4Meta } from "/app/pages/mobile/activities/components/Filter.vue?macro=true";
import { default as FilteramVW3XzDu6LPWLcDObgtt5FMM_45Ntgzj5YUlMyOaHEQoMeta } from "/app/pages/mobile/experience/components/Filter.vue?macro=true";
import { default as Filter3SidDsSea_PmJU83FEXM8KDTLd2GdzrWhkLEwoIcvd8Meta } from "/app/pages/desktop/activities/components/Filter.vue?macro=true";
import { default as FilteredkjpnaROKM6ATWR0_45mkM_45xnko_45fGqAFZJpTbtano1wMeta } from "/app/pages/desktop/experience/components/Filter.vue?macro=true";
import { default as indexDetail5TwEZCuubnsRojZtiEYAlc_4yGcIuV9zKadXOMrFB6AMeta } from "/app/pages/desktop/activities/detail/indexDetail.vue?macro=true";
import { default as indexDesktopZieXPeySAJeQYwtN3dRw_3ndHuBuYRybah9VlqUdBBsMeta } from "/app/pages/desktop/activities/detail/indexDesktop.vue?macro=true";
import { default as SelectDate7X5TFTbwuD5NDuCUn9951FVM26gh63LUTBV_45gLLypeMMeta } from "/app/pages/mobile/activities/components/SelectDate.vue?macro=true";
import { default as SelectDateAYYmC0TDiWWPmOLL5TjUXIY_Rf6HASMwyP0fPFv2z7oMeta } from "/app/pages/mobile/experience/components/SelectDate.vue?macro=true";
import { default as SelectDateOisSRbjlDFu7AWMY2rrjCdI11Xn7MqE_ekWi1zlGVTAMeta } from "/app/pages/desktop/activities/components/SelectDate.vue?macro=true";
import { default as SelectDateLtYjQ_45eP827ugCvbU2kLAtvsJ_45M4r4hnEtPBPqz5OysMeta } from "/app/pages/desktop/experience/components/SelectDate.vue?macro=true";
import { default as indexDetailMobileitv84_45zfDypH_oTOaYS4XtiCX_vbTkEXn5dvsTPzgBEMeta } from "/app/pages/mobile/activities/detail/indexDetailMobile.vue?macro=true";
import { default as ListTopk3tGZP_45ruS7oPpTD5zl8wERNh_45KbH1Xu_KitBtAj6moMeta } from "/app/pages/mobile/attractions/list/_components/ListTop.vue?macro=true";
import { default as ListTopzbRvJlLa3Sjk69G25rPcnmi6Pk_vVtaj5MhYpIMrQZcMeta } from "/app/pages/desktop/attractions/list/_components/ListTop.vue?macro=true";
import { default as _91productSKU_93zX0A9tyzrfqZipqaHiWia_45a_ChEsT77aAi_45PcOctTSEMeta } from "/app/pages/ttd/[language]/[country]/[city]/[productSKU].vue?macro=true";
import { default as SearchBar3CP7Vd1QPO8EFe1l7QRzToqrERiD92QLem1Q0Nm9VVcMeta } from "/app/pages/mobile/attractions/list/_components/SearchBar.vue?macro=true";
import { default as SearchBarZnDODFN2o2k6fZD1hJzSpis_Yl3sWFXnyTEptOAWSi4Meta } from "/app/pages/desktop/attractions/list/_components/SearchBar.vue?macro=true";
import { default as GroupedProductIvPJF2ev1csGMiYGdRJNAyEOrUgoatJuyeKw4TP_45dbIMeta } from "/app/pages/mobile/attractions/detail/_components/GroupedProduct.vue?macro=true";
import { default as GroupedProduct3cNkBscP_vDYJ5_KNStdA4Ha7tY6uzAJnKZmfANxNJkMeta } from "/app/pages/desktop/attractions/detail/_components/GroupedProduct.vue?macro=true";
export default [
  {
    name: "locale",
    path: "/:locale()",
    meta: _91locale_93X3JGk_qgUKdJrKndvgQhpILveeV2Byfp1kQ4yJtPzvcMeta || {},
    component: () => import("/app/pages/[locale].vue")
  },
  {
    name: "mobile",
    path: "/mobile",
    component: () => import("/app/pages/mobile/index.vue")
  },
  {
    name: "desktop",
    path: "/desktop",
    component: () => import("/app/pages/desktop/index.vue")
  },
  {
    name: "ttd-heathCheck",
    path: "/ttd/heathCheck",
    component: () => import("/app/pages/ttd/heathCheck.vue")
  },
  {
    name: "ttd-html-sitemap",
    path: "/ttd/html-sitemap",
    component: () => import("/app/pages/ttd/html-sitemap.vue")
  },
  {
    name: "mobile-coins",
    path: "/mobile/coins",
    component: () => import("/app/pages/mobile/coins/index.vue")
  },
  {
    name: "desktop-coins",
    path: "/desktop/coins",
    component: () => import("/app/pages/desktop/coins/index.vue")
  },
  {
    name: "mobile-payment",
    path: "/mobile/payment",
    component: () => import("/app/pages/mobile/payment/index.vue")
  },
  {
    name: "desktop-payment",
    path: "/desktop/payment",
    component: () => import("/app/pages/desktop/payment/index.vue")
  },
  {
    name: "mobile-order-list",
    path: "/mobile/order/list",
    component: () => import("/app/pages/mobile/order/list/index.vue")
  },
  {
    name: "desktop-order-list",
    path: "/desktop/order/list",
    component: () => import("/app/pages/desktop/order/list/index.vue")
  },
  {
    name: "mobile-order-create",
    path: "/mobile/order/create",
    component: () => import("/app/pages/mobile/order/create/index.vue")
  },
  {
    name: "mobile-order-detail",
    path: "/mobile/order/detail",
    component: () => import("/app/pages/mobile/order/detail/index.vue")
  },
  {
    name: "mobile-order-search",
    path: "/mobile/order/search",
    component: () => import("/app/pages/mobile/order/search/index.vue")
  },
  {
    name: "mobile-order-status",
    path: "/mobile/order/status",
    component: () => import("/app/pages/mobile/order/status/index.vue")
  },
  {
    name: "desktop-order-create",
    path: "/desktop/order/create",
    component: () => import("/app/pages/desktop/order/create/index.vue")
  },
  {
    name: "desktop-order-detail",
    path: "/desktop/order/detail",
    component: () => import("/app/pages/desktop/order/detail/index.vue")
  },
  {
    name: "desktop-order-search",
    path: "/desktop/order/search",
    component: () => import("/app/pages/desktop/order/search/index.vue")
  },
  {
    name: "desktop-order-status",
    path: "/desktop/order/status",
    component: () => import("/app/pages/desktop/order/status/index.vue")
  },
  {
    name: "mobile-order-vouchers",
    path: "/mobile/order/vouchers",
    component: () => import("/app/pages/mobile/order/vouchers/index.vue")
  },
  {
    name: "desktop-order-vouchers",
    path: "/desktop/order/vouchers",
    component: () => import("/app/pages/desktop/order/vouchers/index.vue")
  },
  {
    name: "mobile-attractions-list",
    path: "/mobile/attractions/list",
    component: () => import("/app/pages/mobile/attractions/list/index.vue")
  },
  {
    name: "desktop-attractions-list",
    path: "/desktop/attractions/list",
    component: () => import("/app/pages/desktop/attractions/list/index.vue")
  },
  {
    name: "mobile-experience-detail",
    path: "/mobile/experience/detail",
    component: () => import("/app/pages/mobile/experience/detail/index.vue")
  },
  {
    name: "desktop-experience-detail",
    path: "/desktop/experience/detail",
    component: () => import("/app/pages/desktop/experience/detail/index.vue")
  },
  {
    name: "mobile-attractions-detail",
    path: "/mobile/attractions/detail",
    component: () => import("/app/pages/mobile/attractions/detail/index.vue")
  },
  {
    name: "desktop-attractions-detail",
    path: "/desktop/attractions/detail",
    component: () => import("/app/pages/desktop/attractions/detail/index.vue")
  },
  {
    name: "mobile-activities-components-Filter",
    path: "/mobile/activities/components/Filter",
    component: () => import("/app/pages/mobile/activities/components/Filter.vue")
  },
  {
    name: "mobile-experience-components-Filter",
    path: "/mobile/experience/components/Filter",
    component: () => import("/app/pages/mobile/experience/components/Filter.vue")
  },
  {
    name: "desktop-activities-components-Filter",
    path: "/desktop/activities/components/Filter",
    component: () => import("/app/pages/desktop/activities/components/Filter.vue")
  },
  {
    name: "desktop-experience-components-Filter",
    path: "/desktop/experience/components/Filter",
    component: () => import("/app/pages/desktop/experience/components/Filter.vue")
  },
  {
    name: "desktop-activities-detail-indexDetail",
    path: "/desktop/activities/detail/indexDetail",
    component: () => import("/app/pages/desktop/activities/detail/indexDetail.vue")
  },
  {
    name: "desktop-activities-detail-indexDesktop",
    path: "/desktop/activities/detail/indexDesktop",
    component: () => import("/app/pages/desktop/activities/detail/indexDesktop.vue")
  },
  {
    name: "mobile-activities-components-SelectDate",
    path: "/mobile/activities/components/SelectDate",
    component: () => import("/app/pages/mobile/activities/components/SelectDate.vue")
  },
  {
    name: "mobile-experience-components-SelectDate",
    path: "/mobile/experience/components/SelectDate",
    component: () => import("/app/pages/mobile/experience/components/SelectDate.vue")
  },
  {
    name: "desktop-activities-components-SelectDate",
    path: "/desktop/activities/components/SelectDate",
    component: () => import("/app/pages/desktop/activities/components/SelectDate.vue")
  },
  {
    name: "desktop-experience-components-SelectDate",
    path: "/desktop/experience/components/SelectDate",
    component: () => import("/app/pages/desktop/experience/components/SelectDate.vue")
  },
  {
    name: "mobile-activities-detail-indexDetailMobile",
    path: "/mobile/activities/detail/indexDetailMobile",
    component: () => import("/app/pages/mobile/activities/detail/indexDetailMobile.vue")
  },
  {
    name: "mobile-attractions-list-_components-ListTop",
    path: "/mobile/attractions/list/_components/ListTop",
    component: () => import("/app/pages/mobile/attractions/list/_components/ListTop.vue")
  },
  {
    name: "desktop-attractions-list-_components-ListTop",
    path: "/desktop/attractions/list/_components/ListTop",
    component: () => import("/app/pages/desktop/attractions/list/_components/ListTop.vue")
  },
  {
    name: "ttd-language-country-city-productSKU",
    path: "/ttd/:language()/:country()/:city()/:productSKU()",
    component: () => import("/app/pages/ttd/[language]/[country]/[city]/[productSKU].vue")
  },
  {
    name: "mobile-attractions-list-_components-SearchBar",
    path: "/mobile/attractions/list/_components/SearchBar",
    component: () => import("/app/pages/mobile/attractions/list/_components/SearchBar.vue")
  },
  {
    name: "desktop-attractions-list-_components-SearchBar",
    path: "/desktop/attractions/list/_components/SearchBar",
    component: () => import("/app/pages/desktop/attractions/list/_components/SearchBar.vue")
  },
  {
    name: "mobile-attractions-detail-_components-GroupedProduct",
    path: "/mobile/attractions/detail/_components/GroupedProduct",
    component: () => import("/app/pages/mobile/attractions/detail/_components/GroupedProduct.vue")
  },
  {
    name: "desktop-attractions-detail-_components-GroupedProduct",
    path: "/desktop/attractions/detail/_components/GroupedProduct",
    component: () => import("/app/pages/desktop/attractions/detail/_components/GroupedProduct.vue")
  }
]